/**
 * @file The Price cell of one fetch part. Consumer: `SignifyFetchJobPartTable`.
 * A fetched part prints the formatted value of its first PRICE entry, which is the same entry the
 * record mapping writes; when the vendor returned no such entry the cell falls back to
 * `PricingStatusTag`, so "commission only" and "price refused" keep the words the single-part modal
 * already uses for them rather than reading as a blank cell.
 * Every other state renders an em dash: the price does not exist until the part is fetched.
 */

import { FC } from 'react';
import { Typography } from 'antd';
import { useSnapshot } from 'valtio';
import type { SignifyFetchPart } from '#types';
import PricingStatusTag from '../../SignifyProductModal/components/PricingStatusTag';

const { Text } = Typography;

const SignifyFetchJobPartPriceCell: FC<{ part: SignifyFetchPart }> = ({ part }) => {
  const snap = useSnapshot(part);

  if (snap.state !== 'done') return <Text type="secondary">—</Text>;

  const price = snap.result.price?.prices?.find((entry) => entry.priceTypeIdentifier.includes('PRICE'));
  if (price) return <Text>{price.formattedValue}</Text>;

  return <PricingStatusTag productPriceAndAvailabilityData={snap.result} />;
};

export default SignifyFetchJobPartPriceCell;
